import ReactGA from 'react-ga4';

import { GAEventParams, GAEvents } from './events';

const IS_PROD = import.meta.env.VITE_ENV === 'PROD';
const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID as string | undefined;

/** GA4 초기화 */
export const initGA = () => {
    if (!IS_PROD) {
        console.log('[GA] disabled in non-PROD');
        return;
    }
    if (!GA_MEASUREMENT_ID) {
        console.warn('[GA] Missing VITE_GA_MEASUREMENT_ID');
        return;
    }
    ReactGA.initialize(GA_MEASUREMENT_ID);
    console.log('[GA] initialized');
};

/** 페이지뷰 트래킹 (라우팅 시 호출) */
export const trackPageView = (path: string) => {
    if (!IS_PROD) return;
    ReactGA.send({ hitType: 'pageview', page: path });
};

/** GA4 커스텀 이벤트 (enum 지원) */
export function trackEvent(eventName: GAEvents | string, params?: GAEventParams): void;

/** (하위호환) UA 스타일 시그니처: action/category/label/value */
export function trackEvent(action: string, category: string, label?: string, value?: number): void;

export function trackEvent(a: string, b?: any, c?: any, d?: any) {
    if (!IS_PROD) {
        console.log('[GA Event]:', a, b, c, d);
        return;
    }

    // UA 스타일 호출(기존 코드) 지원
    const calledWithLegacy = typeof b === 'string' || typeof c === 'string' || typeof d === 'number';

    if (calledWithLegacy) {
        ReactGA.event({
            action: a,
            category: b,
            label: c,
            value: d,
        });
        return;
    }

    // GA4 스타일: 이벤트명 + 파라미터
    ReactGA.event(a, b);
}
